"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Breadcrumbs = void 0;
var _reactRouterDom = require("react-router-dom");
var _getSiteMapItem = require("../../utils/getSiteMapItem");
var _Breadcrumb = require("./Breadcrumb");
var _HomeBreadcrumb = require("./HomeBreadcrumb");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const Breadcrumbs = ()=>{
    const location = (0, _reactRouterDom.useLocation)();
    const paths = location.pathname.split('/').filter((x)=>x);
    paths.unshift('');
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_styles.Root, {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_HomeBreadcrumb.HomeBreadcrumb, {}),
            paths.map((path)=>{
                const siteMapItem = (0, _getSiteMapItem.getSiteMapItem)(path);
                if (!siteMapItem) {
                    return null;
                }
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_Breadcrumb.Breadcrumb, {
                    ...siteMapItem
                }, siteMapItem.path);
            })
        ]
    }, location.pathname);
};
exports.Breadcrumbs = Breadcrumbs;
